import block from './block.json';

export const footerThemeAttributes = {
	backgroundColor: '#000000',
	divider: {
		color: '#ffffff',
		width: [1, 1],
	},
	top: {
		padding: {
			top: [40, 60],
			bottom: [20, 40],
		},
	},
	bottom: {
		padding: {
			top: [20, 40],
			bottom: [40, 60],
		},
	},
	text: {
		color: '#ffffff',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	menu: {
		color: '#ffffff',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
	},
	legal: {
		color: '#ffffff',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
};

export const FooterThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: footerThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
